import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Caption, CaptionImage, CaptionHeader } from '../Caption';

import Button from './../Button';
import Location from './../Location';
import { FREE_PLAN } from '../../constants';

class TheaterCard extends Component {
  shouldComponentUpdate = () => false;

  render() {
    const { theater } = this.props;

    const image = theater.images.length > 0 ? theater.images[0].url : '';
    const isFree = theater.plan === FREE_PLAN;

    return (
      <Caption horizontal={isFree}>
        <CaptionImage
          url={image}
        />
        <div className={`caption detail ${isFree && 'horizontal'}`}>
          <CaptionHeader
            noBorder={isFree}
            title={theater.name}
            titleUrl={`/theater/${theater.slug}`}
          />
          {!isFree && (
            <Fragment>
              <Location
                address={`${theater.address}, ${theater.city}, ${theater.country}`}
                text={`${theater.address}, ${theater.city}`}
              />

              <Button blank type="link" url={theater.website} icon="fa-link" value="Página web" />
            </Fragment>
          )}
        </div>
      </Caption>
    );
  }
}

TheaterCard.propTypes = {
  theater: PropTypes.object,
};

TheaterCard.defaultProps = {
  theater: {},
};

export default TheaterCard;



// WEBPACK FOOTER //
// ./src/components/Cards/TheaterCard.js